/**
 * Application release metadata shown on the About page.
 *
 * These values can be overridden at build time via the corresponding
 * REACT_APP_* environment variables so CI can stamp each build; otherwise
 * the constants below act as the defaults for the current release.
 */
export const APP_VERSION = process.env.REACT_APP_VERSION ?? "2.7.2"

export const APP_RELEASE_DATE = process.env.REACT_APP_RELEASE_DATE ?? "10 September 2026"

export const APP_BUILD_NUMBER =
  process.env.REACT_APP_BUILD_NUMBER ?? "LW-20260910-01"
